import styled from 'styled-components';

export const StyledProgressFeedback = styled.div`
  .clickable {
    cursor: pointer;
  }
  .progress-slot-tooltip {
    position: relative;

    .out-of-date {
      position: absolute;
      top: calc(50% - ${({ size }) => (size == 'small' ? '5px' : '9px')});
      left: calc(50% - ${({ size }) => (size == 'small' ? '5px' : '9px')});
      font-size: ${({ size }) => (size == 'small' ? '10px' : '18px')};
      width: ${({ size }) => (size == 'small' ? '10px' : '18px')};
      height: ${({ size }) => (size == 'small' ? '10px' : '18px')};
    }
  }

  .progress-slot.active {
    animation: scaleEffect 0.6s ease-in-out infinite alternate;
  }

  @keyframes scaleEffect {
    from {
      transform: scale(1);
    }
    to {
      transform: scale(1.2);
    }
  }
`;

export const StyledTooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  .late-message {
    padding: 10px;
    border-radius: 4px;
    background-color: #fff2;
    display: flex;
    flex-direction: column;
    gap: 5px;
  }
`;
